/// <amd-module name="DirtyDocumentServices/index" />
export { DirtyDocumentService, DirtyDocumentServiceName, IDirtyDocumentService } from "Services/DirtyDocumentService";
export { BeforePageSwitchService, BeforePageSwitchServiceName, IBeforePageSwitchService } from "Services/BeforePageSwitchService";
